import { useQuery } from '@apollo/react-hooks'
import { Maybe, InstagramPostConnection, LIST_INSTAGRAM_POSTS } from 'vo-components'

export function useInstagramPostsQuery() {
    return useQuery<{ listInstagramPosts: Maybe<InstagramPostConnection> }>(LIST_INSTAGRAM_POSTS)
}
